
export class OrganizationDetails {
  orgReportHeader!: {
    id: number;
    imagePath: string;
    phone: string;
    name: string;
    tenantId: number;
  }
}
